module.exports = __webpack_public_path__ + "static/img/service-flow-circRNA.636baec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/service-flow-circRNA.png
// module id = pCA/
// module chunks = 16